import type { IClient } from '@/entities/client.entity';

type ClientPhotoScanBannerProps = {
	client: IClient;
};

function statusLabel(status: string | undefined): string {
	switch (status) {
		case 'scanning':
			return 'Сканирование…';
		case 'paused':
			return 'Пауза';
		case 'done':
			return 'Завершено';
		default:
			return 'Ожидание';
	}
}

export default function ClientPhotoScanBanner({ client }: ClientPhotoScanBannerProps) {
	if (!client.photoScanStatus || client.photoScanStatus === 'idle') {
		return null;
	}

	const scanned = client.photoScanScanned ?? 0;
	const total = client.photoScanTotal ?? 0;
	const matched = client.photoScanMatched ?? 0;
	const uploaded = client.photoScanUploaded ?? 0;
	const errors = client.photoScanErrors ?? 0;

	return (
		<div className='rounded-md border border-border/60 bg-muted/40 px-3 py-2 text-xs text-muted-foreground'>
			<div className='font-medium text-foreground'>{statusLabel(client.photoScanStatus)}</div>
			<div className='mt-1 flex flex-wrap gap-x-3 gap-y-1'>
				<span>Просмотрено: {scanned}{total > 0 ? ` / ${total}` : ''}</span>
				<span>Совпадений: {matched}</span>
				<span>Загружено: {uploaded}</span>
				{errors > 0 && <span className='text-destructive'>Ошибок: {errors}</span>}
			</div>
		</div>
	);
}
